<template>
  <div class="view-home">
    <div class="container">
      <div class="quiz-status my-4">
        <div class="card" v-show="countdown">
          <ul>
            <li class="time">
              {{ countdown }}
            </li>
            <li class="recording" v-if="quiz.proctoring">
              {{ $t('testing.recording') }}
            </li>
            <li class="interruption" v-if="quiz.proctoring">
              {{ $t('testing.interruption') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container questions-wrap composing-image-block">
      <h2>
        {{ $t('creativity-15-17.title') }}
      </h2>
      <h3>
        {{ $t('creativity-15-17.methodology') }}
      </h3>
      <div class="collaboration-desc" v-html="$t('creativity-15-17.instruction')">
      </div>
      <button class="btn btn-primary" @click="addBlock" :disabled="isButtonDisabled"> + </button>
      <div v-for="(block, blockIndex) in blocks" :key="blockIndex" class="d-flex flex-md-row flex-column">
        <div class="container-image" :ref="'figureContainer' + blockIndex">
          <img
              v-for="(figure, index) in block.figures"
              :key="index"
              :src="figure.src"
              :alt="figure.alt"
              :style="figure.style"
              class="figure draggable"
              @wheel="rotateFigure($event, index, blockIndex)"
              @click="selectFigure(index, blockIndex)"
          />
        </div>
        <div class="container-image-settings">
          <el-input :placeholder="$t('creativity-15-17.namePicture')" v-model="block.nameImage"></el-input>
          <div class="settings-panel" v-if="block.selectedFigure !== null">
            <h3>{{ $t('figureSettings') }}</h3>
            <label>
              {{ $t('angle') }}:
              <input
                  type="range"
                  min="0"
                  max="360"
                  v-model.number="block.figures[block.selectedFigure].style.deg"
                  @input="updateFigureStyle(blockIndex, 'transform', 'rotate(' + $event.target.value + 'deg)')"
              />
              {{ block.figures[block.selectedFigure].style.deg }}
            </label>
            <button class="close-modal-btn" @click="deselectFigure(blockIndex)">✖</button>
          </div>
        </div>
      </div>
<!--      <button @click="saveAsImage">Сохранить</button>-->

      <div id="preview-container" style="margin-top: 20px;"></div>

      <!--      <button @click="sendCollaborationResults">Отправить</button>-->
      <el-button @click="openModal"
                 class="btn btn-danger">{{ $t('testing.finish-modal-button') }}
      </el-button>

    </div>
    <b-modal id="exit-modal" hide-footer hide-header>
      <div id="modal-wrapper">
        <div id="dialog">
          <button @click="$bvModal.hide('exit-modal')" type="button" class="close" data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <img class="modal-warning-img mb-3" src="/images/profile/modal-warning.svg">
          <h3 class="mb-0">{{ modalTitle }}</h3>
          <p>{{ $t('testing.finish-modal-desc') }}</p>
          <div class="clearfix pt-3">
            <el-button @click="sendCreativitySubtest1Results" class="btn btn-primary mx-2">
              {{ $t('testing.finish-modal-button') }}
            </el-button>
            <a @click="$bvModal.hide('exit-modal')"
               class="btn btn-outline-primary mx-2">{{ $t('testing.finish-modal-cancel') }}</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'katex/dist/katex.min.css';
import Loader from '../../components/Loader';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue';
import html2canvas from "html2canvas";

Vue.use(VueViewer)
export default {
  name: "Index",
  data() {
    return {
      modalTitle: this.$t('testing.finish-modal-title'),
      timerInterval: null,
      countdown: 0,
      quiz: '',
      figures: [
        {
          src: "/images/composing/figure1_no_bg.png",
          alt: "figure1",
          style: {top: "10px", left: "10px", transform: "rotate(0deg)", deg: 0}
        },
        {
          src: "/images/composing/figure2_no_bg.png",
          alt: "figure2",
          style: {top: "100px", left: "100px", transform: "rotate(0deg)", deg: 0}
        },
        {
          src: "/images/composing/figure3_no_bg.png",
          alt: "figure3",
          style: {top: "200px", left: "200px", transform: "rotate(0deg)", deg: 0}
        }
      ],
      currentFigure: null,
      selectedFigure: null,
      offsetX: 0,
      offsetY: 0,
      blocks: [
        {
          figures: [
            {
              src: "/images/composing/figure1_no_bg.png",
              alt: "figure1",
              style: {top: "10px", left: "10px", transform: "rotate(0deg)", deg: 0}
            },
            {
              src: "/images/composing/figure2_no_bg.png",
              alt: "figure2",
              style: {top: "100px", left: "100px", transform: "rotate(0deg)", deg: 0}
            },
            {
              src: "/images/composing/figure3_no_bg.png",
              alt: "figure3",
              style: {top: "200px", left: "200px", transform: "rotate(0deg)", deg: 0}
            }
          ],
          currentFigure: null,
          selectedFigure: null,
          offsetX: 0,
          offsetY: 0,
          nameImage: '',
          isModified: false
        }
      ],
      isButtonDisabled: false,
      base64Image: '',
      interpretationResult: {
        high: {
          ru : "Высокий уровень креативности («признаки одаренности»).<br>Признаки:<br>- Отличное воображение: Ты легко представляешь нестандартные образы и идеи. Твое воображение работает активно и ярко, позволяя создавать уникальные концепции и решения.<br>- Способность думать быстро: Ты можешь быстро адаптироваться к изменениям и находить решения в неожиданных ситуациях.<br>- Творческое и оригинальное мышление: Твои идеи часто выходят за рамки стандартных решений и норм. Ты способен находить новые подходы к решению задач.<br>- Разнообразие идей: Ты можешь предложить множество вариантов и идей, которые различаются по стилю и подходу. Рекомендации:<br>- Развивай свои идеи: Постоянно ищи новые возможности для применения своей креативности. Участвуй в проектах и задачах, которые требуют нестандартного подхода.<br>- Общайся с творческими людьми: Сотрудничай и обсуждай свои идеи с другими креативными личностями. Это поможет тебе расширить горизонты и получить новые вдохновения.<br>- Продолжай обучение: Участвуй в курсах и тренингах, которые помогают развивать креативность, например, по креативному мышлению, инновациям и дизайну.",
          kz : "Креативтіліктің жоғары деңгейі («дарындылық белгілері»).<br>Белгілері:<br>- Ұшқыр қиял: Сіз стандартты емес бейнелер мен идеяларды оңай елестете аласыз. Сіздің қиялыңыз белсенді және жарқын жұмыс істейді, бұл сізге бірегей тұжырымдамалар мен шешімдер жасауға мүмкіндік береді.<br>- Тез ойлау қабілеті: сіз өзгерістерге тез бейімделе аласыз және күтпеген жағдайларда шешім таба аласыз.<br>- Шығармашылық және ерекше ойлау: сіздің идеяларыңыз көбінесе стандартты шешімдер мен нормалардан асып түседі. Сіз проблемаларды шешудің жаңа тәсілдерін таба аласыз.<br>- Идеялардың әртүрлілігі: сіз стиль мен тәсілде ерекшеленетін көптеген нұсқалар мен идеяларды ұсына аласыз.<br>Ұсыныстар:<br>- Өз идеяларыңызды дамытыңыз: шығармашылықты қолданудың жаңа мүмкіндіктерін үнемі іздеңіз. Стандартты емес тәсілді қажет ететін жобалар мен міндеттерге қатысыңыз.<br>- Шығармашылық адамдармен байланыс: өз идеяларыңызды басқа шығармашылық тұлғалармен бірлесіп, талқылаңыз. Бұл сізге көкжиектерді кеңейтуге және жаңа шабыт алуға көмектеседі.<br>- Оқуды жалғастырыңыз: шығармашылық ойлау, инновация және дизайн сияқты шығармашылықты дамытуға көмектесетін курстар мен тренингтерге қатысыңыз.",
        },
        middle: {
          ru: "Средний уровень креативности.<br>Признаки:<br>- Хорошее воображение: Ты способен создавать идеи и представления, но иногда тебе может не хватать глубины или новизны.<br>- Достаточная скорость мышления: Ты можешь быстро адаптироваться к изменениям, но иногда твое мышление может замедляться.<br>- Иногда оригинальные идеи: Твои идеи бывают оригинальными, но это происходит не всегда и может требовать дополнительных усилий.<br>- Некоторое разнообразие идей: Ты можешь предлагать разнообразные идеи, но они могут быть менее креативными по сравнению с идеями людей с высоким уровнем креативности.<br>Рекомендации:<br>- Посещай психологические занятия: Занятия, которые сосредоточены на развитии креативности и креативного мышления, помогут тебе раскрыть свой потенциал.<br>- Работай над улучшением воображения: Проводя регулярные упражнения для развития воображения, например, медитации, чтение книг по креативности, можно улучшить свои креативные способности.<br>- Изучай примеры инновационного мышления: Ознакомься с работами и подходами известных креативных личностей, чтобы вдохновляться и развивать свои собственные идеи.",
          kz: "Креативтіліктің орташа деңгейі<br>Белгілері:<br>- Жақсы қиял: Сіз идеялар мен түсініктер жасай аласыз, бірақ кейде сізге тереңдік немесе жаңалық жетіспеуі мүмкін.<br>- Ойлаудың жеткілікті жылдамдығы: сіз өзгерістерге тез бейімделе аласыз, бірақ кейде сіздің ойыңыз баяулауы мүмкін.<br>- Кейде болатын ерекше идеялар: сіздің идеяларыңыз ерекше, бірақ бұл әрдайым бола бермейді және қосымша күш жұмсауды қажет етуі мүмкін.<br>- Идеялардың әртүрлілігі: сіз әртүрлі идеяларды ұсына аласыз, бірақ олар шығармашылық деңгейі жоғары адамдардың идеяларымен салыстырғанда аз шығармашылық болуы мүмкін.<br>Ұсыныстар:<br>- Психологиялық сабақтарға қатысыңыз: шығармашылық пен шығармашылық ойлауды дамытуға бағытталған сабақтар сіздің әлеуетіңізді ашуға көмектеседі.<br>- Қиялды жақсарту үшін жұмыс жасаңыз: қиялды дамыту үшін үнемі жаттығулар жасау, мысалы, медитация, Шығармашылық туралы кітап оқу, шығармашылық қабілеттеріңізді жақсартуға болады.<br>- Инновациялық ойлаудың мысалдарын зерттеңіз: өз идеяларыңызды шабыттандыру және дамыту үшін танымал шығармашылық тұлғалардың жұмыстары мен тәсілдерімен танысыңыз.",
        },
        low: {
          ru: "Креативность «в зоне ближайшего развития».<br>Признаки:<br>- Хорошее воображение: У тебя есть способность к созданию образов и идей, но тебе может не хватать скорости или оригинальности мышления.<br>- Медленное или менее оригинальное мышление: Твое мышление может быть менее гибким, а идеи – менее инновационными.<br>- Трудности с созданием оригинальных историй: Возможно, тебе сложно придумывать уникальные сюжеты и концепции, что может затруднять творческую деятельность.<br>Рекомендации:<br>- Посещай психологические занятия: Специализированные тренинги и занятия помогут тебе развить креативные навыки и научат методам улучшения креативного мышления.<br>- Развивай навыки самостоятельного мышления: Проводя упражнения, направленные на развитие оригинального мышления и творчества, такие как написание собственных рассказов или создание уникальных проектов, можно повысить уровень креативности.<br>- Используй креативные техники: Пробуй методы, которые помогают стимулировать креативность, такие как «мозговой штурм», «карты разума» или «техника случайных слов».",
          kz: "Креативтілік «жақын даму аймағы»<br>Белгілері:<br>- Жақсы қиял: сізде бейнелер мен идеялар жасау мүмкіндігі бар, бірақ сізде ойлау жылдамдығы немесе өзіндік ерекшелігі болмауы мүмкін.<br>- Ерекше ойлаудың аз немесе баяу болуы: сіздің ойлауыңыздың икемділігі төмен болуы мүмкін, ал идеялардың жаңашылдығы аз болуы мүмкін.<br>- Ерекше қиялдағы ойды жасаудағы қиындықтар: шығармашылық әрекетті қиындататын бірегей сюжеттер мен тұжырымдамаларды ойлап табу қиын болуы мүмкін.<br>Ұсыныстар:<br>- Психологиялық сабақтарға қатысыңыз: мамандандырылған тренингтер мен сабақтар сізге шығармашылық дағдыларды дамытуға көмектеседі және шығармашылық ойлауды жақсарту әдістерін үйретеді.<br>- Өз бетіңізше ойлау дағдыларын дамытыңыз: өз әңгімелеріңізді жазу немесе бірегей жобалар жасау сияқты өзіндік ойлау мен шығармашылықты дамытуға бағытталған жаттығулар жасай отырып, шығармашылық деңгейін арттыруға болады.<br>- Шығармашылық әдістерді қолданыңыз: «миға шабуыл», «ақыл карталары» немесе «кездейсоқ сөз техникасы» сияқты шығармашылықты ынталандыруға көмектесетін әдістерді қолданып көріңіз."
        },
      }
      // interpretationResult: {
      //   high: this.$t('creativity-15-17.interpretation-high'),
      //   middle: this.$t('creativity-15-17.interpretation-middle'),
      //   low: this.$t('creativity-15-17.interpretation-low'),
      // }
    };
  },
  methods: {
    addBlock() {
      this.blocks.push({
        figures: [
          {
            src: "/images/composing/figure1_no_bg.png",
            alt: "figure1",
            style: {top: "10px", left: "10px", transform: "rotate(0deg)", deg: 0}
          },
          {
            src: "/images/composing/figure2_no_bg.png",
            alt: "figure2",
            style: {top: "100px", left: "100px", transform: "rotate(0deg)", deg: 0}
          },
          {
            src: "/images/composing/figure3_no_bg.png",
            alt: "figure3",
            style: {top: "200px", left: "200px", transform: "rotate(0deg)", deg: 0}
          }
        ],
        currentFigure: null,
        selectedFigure: null,
        offsetX: 0,
        offsetY: 0,
        nameImage: '',
        isModified: false
      });

      this.$nextTick(() => {
        document.querySelectorAll('.draggable').DraggableJS();
      });

      this.isButtonDisabled = true;
      setTimeout(() => {
        this.isButtonDisabled = false;
      }, 10000);
    },
    deselectFigure(blockIndex) {
      this.blocks[blockIndex].selectedFigure = null;
    },
    selectFigure(index, blockIndex) {
      this.blocks[blockIndex].selectedFigure = index;
    },
    updateFigureStyle(blockIndex, property, value) {
      this.$set(this.blocks[blockIndex].figures[this.blocks[blockIndex].selectedFigure].style, property, value);
    },
    startDrag(event, index, blockIndex) {
      const block = this.blocks[blockIndex];
      block.currentFigure = index;
      const figure = event.target;

      const isTouchEvent = event.type === "touchstart";
      const clientX = isTouchEvent ? event.touches[0].clientX : event.clientX;
      const clientY = isTouchEvent ? event.touches[0].clientY : event.clientY;

      block.offsetX = clientX - figure.offsetLeft;
      block.offsetY = clientY - figure.offsetTop;

      if (isTouchEvent) {
        document.addEventListener("touchmove", this.drag, { passive: false });
        document.addEventListener("touchend", this.stopDrag);
      } else {
        document.addEventListener("mousemove", this.drag);
        document.addEventListener("mouseup", this.stopDrag);
      }

      event.preventDefault();
    },

    drag(event) {
      const blockIndex = this.blocks.findIndex(block => block.currentFigure !== null);
      if (blockIndex === -1) return;

      const block = this.blocks[blockIndex];
      const figure = block.figures[block.currentFigure];

      const isTouchEvent = event.type === "touchmove";
      const clientX = isTouchEvent ? event.touches[0].clientX : event.clientX;
      const clientY = isTouchEvent ? event.touches[0].clientY : event.clientY;

      const newLeft = Math.max(1, Math.min(clientX - block.offsetX, 310));
      const newTop = Math.max(1, Math.min(clientY - block.offsetY, 310));

      figure.style.left = `${newLeft}px`;
      figure.style.top = `${newTop}px`;

      block.isModified = true;
    },

    stopDrag() {
      const blockIndex = this.blocks.findIndex(block => block.currentFigure !== null);
      if (blockIndex === -1) return;

      const block = this.blocks[blockIndex];
      block.currentFigure = null;

      document.removeEventListener("mousemove", this.drag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchmove", this.drag);
      document.removeEventListener("touchend", this.stopDrag);
    },
    rotateFigure(event, index, blockIndex) {
      event.preventDefault();
      const figure = this.blocks[blockIndex].figures[index];

      if (!figure.style.transform) {
        figure.style.transform = 'rotate(0deg)';
      }

      const currentRotation = this.getRotation(figure.style.transform);
      const newRotation = currentRotation + (event.deltaY > 0 ? 15 : -15);
      figure.style.transform = `rotate(${newRotation}deg)`;
    },
    getRotation(transform) {
      const match = transform.match(/rotate\(([-\d.]+)deg\)/);
      return match ? parseFloat(match[1]) : 0;
    },
    async saveAsImage() {
      // временный контейнер
      const tempContainer = document.createElement("div");
      tempContainer.style.position = "absolute";
      tempContainer.style.left = "-9999px";
      tempContainer.style.top = "0";

      this.blocks.forEach((_, blockIndex) => {
        const container = this.$refs['figureContainer' + blockIndex][0].cloneNode(true);
        tempContainer.appendChild(container);
      });

      document.body.appendChild(tempContainer);
      const canvas = await html2canvas(tempContainer);
      const dataURL = canvas.toDataURL("image/png");
      this.base64Image = dataURL.replace(/^data:image\/png;base64,/, "");

      document.body.removeChild(tempContainer);

      // const imageElement = document.createElement("img");
      // imageElement.src = dataURL;
      // imageElement.alt = "Сохраненное изображение";
      // imageElement.style.maxWidth = "100%";
      //
      // const previewContainer = document.getElementById("preview-container");
      // previewContainer.innerHTML = "";
      // previewContainer.appendChild(imageElement);
    },
    openModal() {
      this.$bvModal.show('exit-modal');
    },
    async sendCreativitySubtest1Results() {
      await this.saveAsImage()
      let params = JSON.parse(localStorage.getItem('quiz-params-15-17'))
      const quizToken = localStorage.getItem('quiz-token')
      const validBlocksLength = this.blocks.filter(block => block.nameImage && block.nameImage.length >= 3).length;
      const blocksToSend = this.blocks.map(obj => {
        const {currentFigure, selectedFigure, offsetX, offsetY, ...rest} = obj;
        return rest;
      });

      const creativitySubtest1Data = {
        score: validBlocksLength,
        addInfo: {blocks: blocksToSend},
        userImage: this.base64Image,
        interpret: this.interpretScore(validBlocksLength)
      }

      params.answer_id = {...params.answer_id, creativitySubtest1Data}
      localStorage.setItem('quiz-params-15-17', JSON.stringify(params))

      console.log('params', params)

      const response = await this.$http.post(API_ROOT + '/api/user-answer/' + quizToken, params)

      if (response.body.status == 'success') {

        localStorage.setItem('current-test', 'creativity-subtest-2')

        Vue.toastr({
          message: this.$t('successful'),
          description: this.$t('saved-successfully'),
          type: 'success'
        })
      } else {
        Vue.toastr({
          message: this.$t('error-title'),
          description: this.$t('error-saving'),
          type: 'error'
        })
      }

      setTimeout(() => {
        this.$router.push({ path: '/creativity-subtest-2' })
      }, 1500)

    },
    interpretScore(score) {
      if (score >= 25) {
        return this.interpretationResult.high;
      } else if (score >= 10) {
        return this.interpretationResult.middle;
      } else {
        return this.interpretationResult.low;
      }
    },
    startTimer(duration) {
      let timer = duration, minutes, seconds;
      this.timerInterval = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.countdown = minutes + ":" + seconds;

        let savedTimer = (parseInt(minutes) * 60) + parseInt(seconds);
        localStorage.setItem('timerCreativitySubtest1', savedTimer);

        if (--timer < 0) {
          this.sendCreativitySubtest1Results()
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    redirectIfEnded() {
      const quizToken = localStorage.getItem('quiz-token');
      const userQuizId = localStorage.getItem('user_quiz_id');
      const quizEnded = localStorage.getItem('quiz-ended');

      if (quizEnded && quizEnded === `${userQuizId}-${quizToken}`) {
        window.location.href = `${window.QABILET_ROOT}/test-results-15-17/${userQuizId}/${quizToken}`
      }
    },
  },
  mounted() {
    this.redirectIfEnded();

    if (localStorage.getItem('timerCreativitySubtest1')) {
      this.startTimer(localStorage.getItem('timerCreativitySubtest1'))
    } else {
      this.startTimer(300)
    }

    if (localStorage.getItem('current-test')) {
      this.$router.push({name: localStorage.getItem('current-test')});
    }

    const testLang = localStorage.getItem('test_lang');
    if (testLang) this.$i18n.locale = testLang;

    this.$nextTick(() => {
        document.querySelectorAll('.draggable').DraggableJS();
    });
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  }
}
</script>

<style>
.select-custom-collaboration {
  width: 240px !important;
}

.collaboration-desc {
  margin: 20px 0;
}

.collaboration-options {
  cursor: pointer;
  position: relative;
}

.el-select-group__title {
  position: relative;
}

.el-select-group__title::after {
  position: absolute;
  right: 10px;
  top: 2px;
  content: '▼';
}

.container-image {
  width: 400px;
  height: 400px;
  border: 2px dashed #ccc;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.figure {
  position: absolute;
  cursor: grab;
  user-select: none;
  width: 80px;
  height: auto;
  transition: transform 0.1s ease;
}

.figure {
  -webkit-user-drag: none;
  user-select: none;
  touch-action: none;
  cursor: grab;
}

@media screen and (max-width: 500px) {
  .container-image {
    width: 100%;
  }
}


</style>
